import { useContext } from "react";

import { OrganizationsContext } from "@/contexts/organizations";
import {
  hasAdminProviderRole,
  hasAdminRole,
  hasAnyPermission,
  hasBillerManagerPermission,
  hasBillerRole,
  hasChartExportPermission,
  hasClientOverviewTabsPermission,
  hasDoulaRole,
  hasEncounterSignPermission,
  hasFlagWritePermission,
  hasFormsSendPermission,
  hasLabOrderPermission,
  hasLabResultsViewPermission,
  hasManagerRole,
  hasProviderOrScribeRole,
  hasProviderRole,
  hasReaderRole,
  hasScribeRole,
  hasWriteRole,
} from "@/permission/utils/practitioner-permissions";

export function usePractitionerPermissions() {
  const { permissions } = useContext(OrganizationsContext);

  return {
    permissions,
    hasAdminRole: hasAdminRole(permissions),
    hasAdminProviderRole: hasAdminProviderRole(permissions),
    hasManagerRole: hasManagerRole(permissions),
    hasProviderRole: hasProviderRole(permissions),
    hasScribeRole: hasScribeRole(permissions),
    hasBillerRole: hasBillerRole(permissions),
    hasBillerManagerPermission: hasBillerManagerPermission(permissions),
    hasDoulaRole: hasDoulaRole(permissions),
    hasReaderRole: hasReaderRole(permissions),
    hasWriteRole: hasWriteRole(permissions),
    hasProviderOrScribeRole: hasProviderOrScribeRole(permissions),
    hasEncounterSignPermission: hasEncounterSignPermission(permissions),
    hasChartExportPermission: hasChartExportPermission(permissions),
    hasLabOrderPermission: hasLabOrderPermission(permissions),
    hasLabResultsViewPermission: hasLabResultsViewPermission(permissions),
    hasFlagWritePermission: hasFlagWritePermission(permissions),
    hasFormsSendPermission: hasFormsSendPermission(permissions),
    hasAnyPermission: hasAnyPermission(permissions),
    hasClientOverviewTabsPermission: hasClientOverviewTabsPermission(permissions),
  };
}
